<script>
	import '/src/shared/assets/all.min.css';
	import '/src/shared/assets/app.css';

	export default {
		data() {
			return {
				rep_counter: 1000,
				isOnline: false,
				online: 0,
				mobile_menu: false,
			}
		},
		async created() {
			await this.initializeServiceWorker()
		},
		methods: {
			initializeServiceWorker() {
				Promise.all([
					navigator.serviceWorker.ready,
					navigator.serviceWorker.register('/sw.js')
				]).then(([registration]) => {
					let worker = null;

					if (navigator.serviceWorker.controller !== null) {
						worker = navigator.serviceWorker.controller;
					}

					if (registration.active !== null) {
						worker = registration.active;
					}

					if (registration.waiting !== null) {
						worker = registration.waiting;
					}

					if (registration.installing !== null) {
						worker = registration.installing;
					}

					if (worker == null) {
						// fall back
						return;
					}

					worker.postMessage({ type: 'ping' });
					// отправка пинга раз в 5 секунд
					setInterval(() => {
						console.log('Send to SW')
						worker.postMessage({ type: 'ping' });
					}, 5000);

					navigator.serviceWorker.addEventListener('message', (event) => {
						const { type, count } = event.data;
						
						if (type === 'online_update') {
							this.online = count;
							this.isOnline = count > 0;
						}
					});
				}).catch(() => {
					// fall back
					console.log('ServiceWorker not supported');
				});
			}
		},
		computed: {
			pathname() {
				return this.$route.path;
			}
		},
	}
</script>


<template>
	<div class="header">
		<div @click="this.$router.push('/')" class="logo">

		</div>
		<div class="nav">
			<span :class="`nav-buttn ${this.pathname === '/' ? 'active' : ''}`" @click="this.$router.push('/')">
				Главная
			</span>

			<span :class="`nav-buttn ${this.pathname === '/ps-store' ? 'active' : ''}`"
				@click="this.$router.push('/ps-store')">
				PS Store
			</span>

			<span :class="`nav-buttn ${this.pathname === '/mobile-games' ? 'active' : ''}`"
				@click="this.$router.push('/mobile-games')">
				Мобильные игры
			</span>

			<span :class="`nav-buttn ${this.pathname === '/steam-gift' ? 'active' : ''}`"
				@click="this.$router.push('/steam-gift')">
				Гифты
			</span>

			<span :class="`nav-buttn ${this.pathname === '/giveaway' ? 'active' : ''}`"
				@click="this.$router.push('/giveaway')">
				Раздача
			</span>

			<span :class="`nav-buttn ${this.pathname === '/faq' ? 'active' : ''}`"
				@click="this.$router.push('/faq')">
				FAQ
			</span>

				<span :class="`nav-buttn ${this.pathname === '/support' ? 'active' : ''}`"
					@click="this.$router.push('/support')">
					Поддержка
				</span>

				<span :class="`nav-buttn ${this.pathname === '/comms' ? 'active' : ''}`"
					@click="this.$router.push('/comms')">
					Отзывы
				</span>
			</div>
			<div class="mobile-menu-button-col">
			<button @click="mobile_menu = !mobile_menu" type="button" class="mobile-menu-button"><i
					class="fa-solid fa-bars"></i></button>
		</div>
		<div v-bind:style="mobile_menu ? { 'display': 'block' } : { 'display': 'none !important' }" class="col-lg-8 header-nav-menu">
			<div v-bind:style="mobile_menu ? { 'display': 'block' } : { 'display': 'none !important' }" class="header-nav-menu-inner">
				<div class="row">
					<div class="col-lg-12">
						<div class="main-menu">
							<ul>

								<li :class="`${this.pathname === '/' ? 'active' : ''}`">
									<a @click="this.$router.push('/')"><i class="fa-regular fa-house"></i>Главная</a>
								</li>
								<li :class="`${this.pathname === '/ps-store' ? 'active' : ''}`">
									<a @click="this.$router.push('/ps-store')"><i class="fa-regular fa-gamepad"></i>PS Store</a>
								</li>
								<li :class="`${this.pathname === '/mobile-games' ? 'active' : ''}`">
									<a @click="this.$router.push('/mobile-games')"><i class="fa-regular fa-mobile"></i>Мобильные игры</a>
								</li>
								<li :class="`${this.pathname === '/steam-gift' ? 'active' : ''}`">
									<a @click="this.$router.push('/steam-gift')"><i class="fa-regular fa-gift"></i>Гифты</a>
								</li>
								<li :class="`${this.pathname === '/giveaway' ? 'active' : ''}`">
									<a @click="this.$router.push('/giveaway')"><i class="fa-regular fa-trophy-star"></i>Раздача</a>
								</li>
								<li :class="`${this.pathname === '/faq' ? 'active' : ''}`">
									<a @click="this.$router.push('/faq')"><i class="fa-regular fa-circle-question"></i>FAQ</a>
								</li>
									<li :class="`${this.pathname === '/support' ? 'active' : ''}`">
										<a @click="this.$router.push('/support')"><i class="fa-regular fa-shield-heart"></i>Поддержка
										</a>
									</li>
									<li :class="`${this.pathname === '/comms' ? 'active' : ''}`">
										<a @click="this.$router.push('/comms')"><i class="fa-regular fa-comments"></i>Отзывы</a>
									</li>


							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.main-menu ul li.active {
	opacity: 1;
}
.main-menu a.active {
	cursor: pointer;
}
.main-menu a {
	cursor: pointer;
}
.header {
    background-color: black;
    height: 82px;
    display: flex;
    align-items: center;
    padding: 0 80px;
	gap: 40px;
}

.logo {
    background-image: url("@/app/assets/logo_new.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    width: 306px;
    height: 54px;
    margin-right: auto;
	margin-left: 130px;
	flex-shrink: 0;
	cursor: pointer;
}

.nav {
    display: flex;
    gap: 40px;
	margin-right: 100px;
}

.nav-buttn {
    cursor: pointer;
    user-select: none;
    color: white;
    font-family: "Inter", sans-serif;
	white-space: nowrap;
	transition: all .2s;
}
.nav-buttn:hover {
	color: #01E4FF;
}
.nav-buttn.active {
	color: #01E4FF;
}

@media (max-width: 1400px) {
    .header {
        padding: 0 40px;
        gap: 20px;
    }
    
    .nav {
        gap: 20px;
    }
}

@media (max-width: 1200px) {
    .header {
        padding: 0 20px;
    }
    
    .info {
        gap: 16px;
    }
}

@media (max-width: 1010px) {
	.logo {
		margin-left: 0;
	}
}

@media (max-width: 992px) {
    .nav {
        gap: 15px;
    }
    
    .nav-buttn {
        font-size: 14px;
    }
}

@media (max-width: 815px) {
    .header {
        justify-content: space-between;
    }
    
    .nav {
        margin-right: 0;
    }
    
    .info {
        margin-left: auto;
    }
}

@media (max-width: 710px) {
	.nav {
        display: none;
    }
}

@media (max-width: 415px) {
	.info {
        display: none;
    }

	.logo {
		margin-right: 0;
	}

	.header {
		justify-content: center;
	}
}

@media (max-width: 768px) {
	.header {
		flex-wrap: wrap;
		height: auto;
		gap: 0;
		padding: 0 20px 20px 20px;
		justify-content: center;
		width: 100%;
	}
	.header-nav-menu,
    .header-nav-menu-inner,
    .row,
    .col-lg-12,
    .col-lg-8 {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 10px !important;
    }
	.logo {
		margin: 0 auto 10px auto;
	}
	.mobile-menu-button-col {
		width: 100%;
		display: flex;
		justify-content: center;
		padding: 0;
		margin: 0;
		height: auto;
		flex: 0 0 100%;
	}
}
@media (max-width: 342px) {
	.header {
		padding: 20px 0;
	}
}

</style>
